import React, { useEffect, useState } from "react";

const fmtUSD = (n,d=2) => `$${Number(n||0).toLocaleString("en-US",{minimumFractionDigits:d,maximumFractionDigits:d})}`;
const fmtPct = (n,d=1) => `${Number(n||0).toFixed(d)}%`;
const clr    = (n) => n>0?"var(--success)":n<0?"var(--danger)":"var(--text-muted)";
const ddClr  = (n) => n>=100?"#c0392b":n>40?"var(--danger)":n>20?"var(--warning)":"var(--success)";
const gradeClr = (g) => ({
  "A+":"var(--success)","A":"var(--success)","A-":"var(--success)",
  "B+":"#6ee7b7","B":"#93c5fd","B-":"#60a5fa",
  "C+":"var(--warning)","C":"var(--warning)","C-":"var(--warning)",
  "D":"var(--danger)","F":"var(--danger)"
}[g] || "var(--text-muted)");

const ConnDot = ({s}) => {
  const c = s==="connected"?"var(--success)":s==="disconnected"?"var(--danger)":"var(--warning)";
  return <span style={{color:c,fontSize:11,fontWeight:600}}>● {s||"unknown"}</span>;
};

const DDBar = ({pct, label}) => {
  const p = Math.min(Number(pct)||0, 100);
  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
        <span style={{fontSize:10,color:"var(--text-muted)"}}>{label}</span>
        <span style={{fontSize:11,fontWeight:700,color:ddClr(p)}}>{fmtPct(p)}</span>
      </div>
      <div style={{height:5,background:"var(--surface-2)",borderRadius:3,overflow:"hidden"}}>
        <div style={{width:p+"%",height:"100%",borderRadius:3,background:ddClr(p),transition:"width 0.4s ease"}}/>
      </div>
    </div>
  );
};

/* ── Subscribed Provider Card ── */
const ProviderCard = ({item}) => {
  const isCopy  = item.type === "copy_trader";
  const typeLabel = isCopy ? "MASTER TRADER" : "MASTER SIGNAL";
  const score   = item.alpha_score||0;
  const scoreClr = score>=80?"var(--success)":score>=65?"var(--accent)":score>=50?"#d4a832":"var(--danger)";
  const scoreBg  = score>=80?"rgba(15,58,42,0.9)":score>=65?"rgba(26,58,92,0.9)":score>=50?"rgba(58,52,26,0.9)":"rgba(58,26,26,0.9)";
  const displayName = item.nickname || item.name || item.account_number;
  const totalPnl  = item.total_pnl  ?? null;
  const monthPnl  = item.month_pnl  ?? null;
  const winRate   = item.win_rate   ?? null;
  const trades    = item.total_trades ?? null;
  const winTrades = item.win_trades  ?? null;

  return (
    <div style={{
      background:"rgba(255,255,255,0.03)",border:"0.5px solid rgba(255,255,255,0.09)",
      borderRadius:12,padding:14,transition:"border-color 0.2s"
    }}
      onMouseEnter={e=>e.currentTarget.style.borderColor="rgba(255,255,255,0.18)"}
      onMouseLeave={e=>e.currentTarget.style.borderColor="rgba(255,255,255,0.09)"}
    >
      {/* top row */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
        <span style={{
          fontSize:10,fontWeight:700,padding:"3px 8px",borderRadius:20,letterSpacing:"0.04em",
          background:isCopy?"rgba(24,95,165,0.2)":"rgba(15,110,86,0.2)",
          color:isCopy?"var(--accent)":"var(--success)",
          border:`0.5px solid ${isCopy?"rgba(var(--accent-rgb,96,170,238),0.3)":"rgba(var(--success-rgb,78,203,138),0.3)"}`
        }}>{typeLabel}</span>
        <span style={{
          fontSize:11,fontWeight:700,padding:"3px 9px",borderRadius:20,fontFamily:"monospace",
          background:scoreBg,color:scoreClr,border:`0.5px solid ${scoreClr}44`
        }}>α {score}{item.grade && item.grade!=="?"?" · "+item.grade:""}</span>
      </div>

      <div style={{fontSize:14,fontWeight:600,color:"var(--text-main)",marginBottom:2}}>{displayName}</div>

      {isCopy && (
        <div style={{fontSize:11,color:"var(--text-muted)",marginBottom:10}}>
          Master DD: <span style={{color:ddClr(item.max_dd_pct||0),fontWeight:600}}>{fmtPct(item.max_dd_pct||0)}</span>
        </div>
      )}

      {/* Stats grid — beda untuk copy vs signal */}
      {isCopy ? (
        <>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,marginBottom:10}}>
            {[
              {label:"All-Time P&L", val:totalPnl!=null?(totalPnl>=0?"+":"")+fmtUSD(totalPnl):"—",  color:totalPnl!=null?clr(totalPnl):"var(--text-muted)"},
              {label:"This Month",   val:monthPnl!=null?(monthPnl>=0?"+":"")+fmtUSD(monthPnl):"—",  color:monthPnl!=null?clr(monthPnl):"var(--text-muted)"},
              {label:"Win Rate",     val:winRate!=null?fmtPct(winRate):"—",                          color:"var(--text-main)"},
              {label:"Trades",       val:trades!=null?trades:"—",                                    color:"var(--text-main)"},
            ].map((s,i)=>(
              <div key={i} style={{background:"rgba(255,255,255,0.04)",borderRadius:8,padding:"7px 9px"}}>
                <div style={{fontSize:10,color:"var(--text-muted)",marginBottom:2,fontFamily:"monospace",textTransform:"uppercase",letterSpacing:"0.04em"}}>{s.label}</div>
                <div style={{fontSize:13,fontWeight:600,color:s.color}}>{s.val}</div>
              </div>
            ))}
          </div>
          <DDBar pct={item.max_dd_pct||0} label="Master DD"/>
        </>
      ) : (
        /* Signal — tampilkan stats sinyal, tidak ada DD bar */
        <>
          <div style={{fontSize:11,color:"var(--text-muted)",marginBottom:10}}>
            Signal provider · {trades!=null?trades:0} signals
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
            {[
              {label:"Avg R:R",       val:item.avg_rr>0?"1:"+Number(item.avg_rr).toFixed(2):"—",           color:"var(--text-main)"},
              {label:"Cumulative R",  val:item.cumulative_r!=null?(item.cumulative_r>=0?"+":"")+Number(item.cumulative_r).toFixed(2)+" R":"—", color:item.cumulative_r>=0?"var(--success)":"var(--danger)"},
              {label:"Win Rate",      val:winRate!=null?fmtPct(winRate):"—",                               color:"var(--text-main)"},
              {label:"Total Signals", val:trades!=null?trades:"—",                                         color:"var(--text-main)"},
              {label:"Profit Factor", val:item.profit_factor>0?Number(item.profit_factor).toFixed(2):"—",  color:item.profit_factor>=1.5?"var(--success)":item.profit_factor>=1?"var(--warning)":"var(--danger)"},
              {label:"Net Pips",      val:item.net_pips!=null?(item.net_pips>=0?"+":"")+Math.round(item.net_pips)+" pts":"—", color:item.net_pips>=0?"var(--success)":"var(--danger)"},
            ].map((s,i)=>(
              <div key={i} style={{background:"rgba(255,255,255,0.04)",borderRadius:8,padding:"7px 9px"}}>
                <div style={{fontSize:10,color:"var(--text-muted)",marginBottom:2,fontFamily:"monospace",textTransform:"uppercase",letterSpacing:"0.04em"}}>{s.label}</div>
                <div style={{fontSize:13,fontWeight:600,color:s.color}}>{s.val}</div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

/* ── Past Provider Card ── */
const PastCard = ({p}) => {
  const isMarginCall = Number(p.max_dd_pct||0) >= 100;
  const score = p.alpha_score||0;
  const scoreClr = score>=80?"var(--success)":score>=65?"var(--accent)":score>=50?"#d4a832":"var(--danger)";
  const scoreBg  = score>=80?"rgba(15,58,42,0.9)":score>=65?"rgba(26,58,92,0.9)":score>=50?"rgba(58,52,26,0.9)":"rgba(58,26,26,0.9)";
  const pnl    = p.total_pnl ?? 0;
  const trades = p.trade_count ?? 0;
  const winRate = trades > 0 ? ((p.win_count||0) / trades * 100) : null;
  return (
    <div style={{
      background:"rgba(255,255,255,0.03)",
      border:`0.5px solid ${isMarginCall?"rgba(42,122,80,0.5)":"rgba(255,255,255,0.09)"}`,
      borderRadius:12,padding:14
    }}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
        <span style={{
          fontSize:10,fontWeight:700,padding:"3px 8px",borderRadius:20,
          background:"rgba(58,31,31,0.8)",color:"var(--danger)",
          border:"0.5px solid rgba(var(--danger-rgb,224,112,112),0.3)",letterSpacing:"0.04em"
        }}>UNSUBSCRIBED</span>
        <span style={{
          fontSize:11,fontWeight:700,padding:"3px 9px",borderRadius:20,fontFamily:"monospace",
          background:scoreBg,color:scoreClr,border:`0.5px solid ${scoreClr}44`
        }}>α {score}{p.grade?" · "+p.grade:""}</span>
      </div>

      <div style={{fontSize:14,fontWeight:600,color:"var(--text-main)",marginBottom:2}}>
        {p.nickname||p.account_number}
      </div>
      <div style={{fontSize:11,color:"var(--text-muted)",marginBottom:10}}>
        {trades} trades · {isMarginCall
          ? <span style={{color:"var(--danger)"}}>Margin Call</span>
          : `Master DD ${fmtPct(p.max_dd_pct||0)}`}
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,marginBottom:10}}>
        {[
          {label:"P&L Generated", val:(pnl>=0?"+":"")+fmtUSD(pnl),               color:clr(pnl)},
          {label:"Master DD",     val:fmtPct(p.max_dd_pct||0),                    color:ddClr(p.max_dd_pct||0)},
          {label:"Trades",        val:trades,                                      color:"var(--text-main)"},
          {label:"Win Rate",      val:winRate!=null?fmtPct(winRate):"—",           color:"var(--text-main)"},
        ].map((s,i)=>(
          <div key={i} style={{background:"rgba(255,255,255,0.04)",borderRadius:8,padding:"7px 9px"}}>
            <div style={{fontSize:10,color:"var(--text-muted)",marginBottom:2,fontFamily:"monospace",textTransform:"uppercase",letterSpacing:"0.04em"}}>{s.label}</div>
            <div style={{fontSize:13,fontWeight:600,color:s.color}}>{s.val}</div>
          </div>
        ))}
      </div>

      <DDBar pct={p.max_dd_pct||0} label={isMarginCall?"Master DD (Margin Call)":"Master DD"}/>
    </div>
  );
};

/* ── Platform Guard Banner — dynamic ── */
const PlatformGuardBanner = ({pastTraders}) => {
  const marginCallList = pastTraders.filter(p => Number(p.max_dd_pct||0) >= 100);
  const highDDList     = pastTraders.filter(p => Number(p.max_dd_pct||0) >= 30);
  const totalProfitPnl = pastTraders
    .filter(p => (p.total_pnl??0) > 0)
    .reduce((s,p) => s + Number(p.total_pnl??0), 0);

  let situation = "";
  if (marginCallList.length > 0) {
    const names = marginCallList.map(p=>p.nickname||p.account_number).join(", ");
    situation = `${names} hit Margin Call (100% DD)`;
  } else if (highDDList.length > 0) {
    const maxDD = Math.max(...highDDList.map(p=>Number(p.max_dd_pct||0)));
    const names = highDDList.map(p=>p.nickname||p.account_number).join(", ");
    situation = `${names} reached ${fmtPct(maxDD)} drawdown`;
  } else {
    const maxDD = Math.max(...pastTraders.map(p=>Number(p.max_dd_pct||0)));
    situation = `Master Trader reached ${fmtPct(maxDD)} drawdown`;
  }

  const profitClause = totalProfitPnl > 0
    ? ` Average follower outcome: +${fmtUSD(totalProfitPnl)}` : "";
  const worstDD = Math.max(...pastTraders.map(p=>Number(p.max_dd_pct||0)));
  return (
    <div style={{
      background:"rgba(15,58,42,0.12)",border:"0.5px solid rgba(42,122,80,0.35)",
      borderRadius:12,padding:"16px 18px",marginTop:14
    }}>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--success)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.25C17.25 22.15 21 17.25 21 12V7L12 2z"/>
          <polyline points="9 12 11 14 15 10"/>
        </svg>
        <span style={{fontSize:12,fontWeight:700,color:"var(--success)",letterSpacing:"0.05em",textTransform:"uppercase"}}>Risk Event Managed</span>
        <span style={{fontSize:10,padding:"2px 8px",borderRadius:20,fontWeight:600,
          background:"rgba(248,113,113,0.12)",color:"var(--danger)",border:"0.5px solid rgba(248,113,113,0.3)"}}>
          Platform Guard Activated
        </span>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:12}}>
        <div style={{background:"rgba(0,0,0,0.2)",borderRadius:8,padding:"10px 12px"}}>
          <div style={{fontSize:10,fontWeight:700,color:"var(--text-muted)",textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:6}}>Provider Account</div>
          {marginCallList.length>0 && <div style={{fontSize:11,fontWeight:700,color:"var(--danger)",marginBottom:4}}>   Margin Call</div>}
          <div style={{fontSize:12,color:"var(--text-muted)"}}>Master DD: <span style={{color:"var(--danger)",fontWeight:700}}>{fmtPct(worstDD)}</span></div>
        </div>
        <div style={{background:"rgba(0,0,0,0.2)",borderRadius:8,padding:"10px 12px"}}>
          <div style={{fontSize:10,fontWeight:700,color:"var(--text-muted)",textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:6}}>Follower Outcome</div>
          {totalProfitPnl>0 && <div style={{fontSize:14,fontWeight:800,color:"var(--success)",marginBottom:2}}>+{fmtUSD(totalProfitPnl)}</div>}
          <div style={{fontSize:11,color:"var(--text-muted)"}}>Avg P&L from past providers</div>
        </div>
        <div style={{background:"rgba(0,0,0,0.2)",borderRadius:8,padding:"10px 12px"}}>
          <div style={{fontSize:10,fontWeight:700,color:"var(--text-muted)",textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:6}}>Protection Applied</div>
          {["AUM-Based Sizing","Platform Guard","Risk Limits"].map((t,i)=>(
            <div key={i} style={{fontSize:11,color:"var(--success)",display:"flex",alignItems:"center",gap:4,marginBottom:2}}>
              <span style={{fontSize:9}}></span>{t}
            </div>
          ))}
        </div>
      </div>
      <p style={{fontSize:11,color:"#7a9a8a",lineHeight:1.6,margin:0}}>
        Provider reached a risk event ({situation}). Due to risk-normalized sizing and Platform Guard, follower accounts were not exposed to the same level of risk.{profitClause}
      </p>
    </div>
  );
}
/* ══════════════════════════════════════════════════════════════════════════ */

export default function InvestorAccountPerformance() {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [expand,  setExpand]  = useState({});

  const authH = () => ({ Authorization:`Bearer ${localStorage.getItem("access_token")||localStorage.getItem("token")||""}` });

  const load = () => {
    fetch("/api/investor/account-performance", { headers:authH() })
      .then(r=>r.json())
      .then(d=>{ if(d.ok) setData(d); })
      .finally(()=>setLoading(false));
  };

  useEffect(()=>{ load(); },[]);

  if (loading) return <div style={{padding:48,textAlign:"center",color:"var(--text-muted)"}}>Loading...</div>;

  const accounts = data?.accounts || [];
  const summary  = data?.summary  || {};

  return (
    <div style={{padding:"24px",maxWidth:1060,margin:"0 auto"}}>
      <div style={{marginBottom:20}}>
        <h1 style={{fontSize:22,fontWeight:800,color:"var(--text-main)",marginBottom:4}}>My Accounts</h1>
        <p style={{fontSize:13,color:"var(--text-muted)"}}>
          Performance per follower account — copy trading + signals results.
        </p>
      </div>

      {/* Summary */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:10,marginBottom:24}}>
        {[
          { label:"Total Equity",   value:fmtUSD(summary.total_equity),  color:"var(--text-main)" },
          { label:"All-Time P&L",   value:fmtUSD(summary.total_pnl),     color:clr(summary.total_pnl) },
          { label:"This Month P&L", value:fmtUSD(summary.month_pnl),     color:clr(summary.month_pnl) },
          { label:"Floating P&L",   value:fmtUSD(summary.floating_pnl),  color:clr(summary.floating_pnl) },
          { label:"Accrued Fee",    value:fmtUSD(summary.accrued_fee),   color:"var(--warning)" },
          { label:"Accounts",       value:summary.account_count||0,      color:"var(--accent)" },
        ].map((c,i)=>(
          <div key={i} style={{background:"var(--bg-surface)",border:"1px solid var(--border)",
            borderRadius:10,padding:"12px 14px"}}>
            <div style={{fontSize:10,color:"var(--text-muted)",marginBottom:4,
              textTransform:"uppercase",letterSpacing:"0.04em"}}>{c.label}</div>
            <div style={{fontSize:17,fontWeight:700,color:c.color}}>{c.value}</div>
          </div>
        ))}
      </div>

      {/* Guard info */}
      <div style={{background:"rgba(99,102,241,0.06)",border:"1px solid rgba(99,102,241,0.2)",
        borderRadius:10,padding:"12px 16px",marginBottom:20,
        display:"flex",gap:20,flexWrap:"wrap",alignItems:"center"}}>
        <div style={{fontSize:12,fontWeight:700,color:"var(--accent)"}}>   Platform Guard Active</div>
        <div style={{fontSize:12,color:"var(--text-muted)"}}>
          Performance fee is only charged on new profit above the High Water Mark.
          High-DD traders can still be copied — risk is visible per account via the DD card.
        </div>
      </div>

      {accounts.length===0 ? (
        <div style={{padding:40,textAlign:"center",color:"var(--text-muted)",fontSize:13}}>
          No follower accounts found.
        </div>
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {accounts.map(a=>{
            const isExp        = expand[a.id];
            const allProviders = [...(a.traders||[]), ...(a.signals||[])];
            const pastTraders  = a.past_traders||[];
            const showBanner   = pastTraders.length > 0 && pastTraders.some(p => Number(p.max_dd_pct||0) >= 30);
            return (
              <div key={a.id} style={{background:"var(--bg-surface)",
                border:"1px solid var(--border)",borderRadius:12,overflow:"hidden"}}>

                {/* Header */}
                <div style={{padding:"14px 20px",cursor:"pointer",
                  borderBottom:isExp?"1px solid var(--border)":"none",
                  display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}
                  onClick={()=>setExpand(e=>({...e,[a.id]:!e[a.id]}))}>

                  <div style={{display:"flex",alignItems:"center",gap:12}}>
                    <div style={{background:"var(--bg-elevated)",borderRadius:7,padding:"5px 11px",
                      fontSize:12,fontWeight:700,color:"var(--accent)"}}>
                      {a.platform}
                    </div>
                    <div>
                      <div style={{fontSize:15,fontWeight:700,color:"var(--text-main)"}}>
                        {a.account_number}
                        <span style={{fontSize:11,color:"var(--text-muted)",fontWeight:400,marginLeft:8}}>
                          {a.broker}
                        </span>
                      </div>
                      <div style={{marginTop:2,display:"flex",gap:10,alignItems:"center"}}>
                        <ConnDot s={a.connection_status}/>
                        <span style={{fontSize:10,color:"var(--text-muted)"}}>
                          {a.trader_count} trader · {a.signal_count} signal
                        </span>
                      </div>
                    </div>
                  </div>

                  <div style={{display:"flex",gap:16,flexWrap:"wrap",alignItems:"center"}}>
                    {[
                      { label:"Equity",      value:fmtUSD(a.equity),    color:"var(--text-main)" },
                      { label:"All-Time P&L",value:fmtUSD(a.total_pnl), color:clr(a.total_pnl) },
                      { label:"This Month",  value:fmtUSD(a.month_pnl), color:clr(a.month_pnl) },
                      { label:"Win Rate",    value:fmtPct(a.win_rate),
                        color:a.win_rate>=55?"var(--success)":a.win_rate>=45?"var(--warning)":"var(--danger)" },
                    ].map((m,i)=>(
                      <div key={i} style={{textAlign:"center"}}>
                        <div style={{fontSize:10,color:"var(--text-muted)"}}>{m.label}</div>
                        <div style={{fontSize:13,fontWeight:700,color:m.color}}>{m.value}</div>
                      </div>
                    ))}
                    {a.open_positions>0 && (
                      <div style={{textAlign:"center"}}>
                        <div style={{fontSize:10,color:"var(--text-muted)"}}>Floating</div>
                        <div style={{fontSize:13,fontWeight:700,color:clr(a.floating_pnl)}}>
                          {fmtUSD(a.floating_pnl)}
                        </div>
                      </div>
                    )}
                    <span style={{fontSize:14,color:"var(--text-muted)"}}>{isExp?"▲":"▼"}</span>
                  </div>
                </div>

                {/* Expanded */}
                {isExp && (
                  <div style={{padding:"16px 20px"}}>
                    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:12,marginBottom:16}}>

                      {/* P&L */}
                      <div style={{background:"var(--bg-elevated)",borderRadius:8,padding:"12px 14px"}}>
                        <div style={{fontSize:10,color:"var(--text-muted)",marginBottom:8,
                          textTransform:"uppercase",letterSpacing:"0.04em",fontWeight:700}}>P&L</div>
                        {[
                          { label:"All Time",        value:a.total_pnl,   bold:true },
                          { label:"This Month",      value:a.month_pnl },
                          { label:"This Week",       value:a.week_pnl },
                          { label:"Floating",        value:a.floating_pnl },
                          { label:"Net (after fee)", value:a.net_pnl, bold:true },
                        ].map((r,i)=>(
                          <div key={i} style={{display:"flex",justifyContent:"space-between",
                            padding:r.bold?"4px 0":"2px 0",
                            borderTop:r.bold?"1px solid var(--border)":"none",marginBottom:3}}>
                            <span style={{fontSize:12,color:"var(--text-muted)"}}>{r.label}</span>
                            <span style={{fontSize:12,fontWeight:r.bold?700:400,color:clr(r.value)}}>
                              {fmtUSD(r.value)}
                            </span>
                          </div>
                        ))}
                      </div>

                      {/* Trade stats */}
                      <div style={{background:"var(--bg-elevated)",borderRadius:8,padding:"12px 14px"}}>
                        <div style={{fontSize:10,color:"var(--text-muted)",marginBottom:8,
                          textTransform:"uppercase",letterSpacing:"0.04em",fontWeight:700}}>Trade Stats</div>
                        {[
                          { label:"Total Trades", value:a.total_trades },
                          { label:"Wins",         value:a.win_trades },
                          { label:"Losses",       value:(a.total_trades||0)-(a.win_trades||0) },
                        ].map((r,i)=>(
                          <div key={i} style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
                            <span style={{fontSize:12,color:"var(--text-muted)"}}>{r.label}</span>
                            <span style={{fontSize:12,fontWeight:500,color:"var(--text-main)"}}>{r.value}</span>
                          </div>
                        ))}
                        <div style={{marginTop:8}}>
                          <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
                            <span style={{fontSize:11,color:"var(--text-muted)"}}>Win Rate</span>
                            <span style={{fontSize:12,fontWeight:700,
                              color:a.win_rate>=55?"var(--success)":a.win_rate>=45?"var(--warning)":"var(--danger)"}}>
                              {fmtPct(a.win_rate)}
                            </span>
                          </div>
                          <div style={{height:6,background:"var(--surface-2)",borderRadius:3,overflow:"hidden"}}>
                            <div style={{width:(a.win_rate||0)+"%",height:"100%",borderRadius:3,
                              background:a.win_rate>=55?"var(--success)":a.win_rate>=45?"var(--warning)":"var(--danger)"}}/>
                          </div>
                        </div>
                      </div>

                      {/* Fee & HWM */}
                      <div style={{background:"var(--bg-elevated)",borderRadius:8,padding:"12px 14px"}}>
                        <div style={{fontSize:10,color:"var(--text-muted)",marginBottom:8,
                          textTransform:"uppercase",letterSpacing:"0.04em",fontWeight:700}}>Fee Guard</div>
                        {[
                          { label:"Cum. Copy P&L",  value:fmtUSD(a.cumulative_pnl), color:clr(a.cumulative_pnl) },
                          { label:"High Water Mark", value:fmtUSD(a.hwm_pnl),        color:"var(--text-muted)" },
                          { label:"Above HWM",       value:fmtUSD(Math.max(0,(a.cumulative_pnl||0)-(a.hwm_pnl||0))), color:"var(--accent)" },
                          { label:"Accrued Fee",     value:fmtUSD(a.accrued_fee),    color:"var(--warning)" },
                        ].map((r,i)=>(
                          <div key={i} style={{display:"flex",justifyContent:"space-between",marginBottom:5}}>
                            <span style={{fontSize:12,color:"var(--text-muted)"}}>{r.label}</span>
                            <span style={{fontSize:12,fontWeight:600,color:r.color}}>{r.value}</span>
                          </div>
                        ))}
                      </div>

                      {/* Account info */}
                      <div style={{background:"var(--bg-elevated)",borderRadius:8,padding:"12px 14px"}}>
                        <div style={{fontSize:10,color:"var(--text-muted)",marginBottom:8,
                          textTransform:"uppercase",letterSpacing:"0.04em",fontWeight:700}}>Account</div>
                        {[
                          { label:"Equity",    value:fmtUSD(a.equity) },
                          { label:"Balance",   value:fmtUSD(a.balance) },
                          { label:"Open Pos",  value:`${a.open_positions||0} pos` },
                          { label:"Avg Score", value:Number(a.avg_alpha_score||0).toFixed(1) },
                        ].map((r,i)=>(
                          <div key={i} style={{display:"flex",justifyContent:"space-between",marginBottom:5}}>
                            <span style={{fontSize:12,color:"var(--text-muted)"}}>{r.label}</span>
                            <span style={{fontSize:12,color:"var(--text-main)"}}>{r.value}</span>
                          </div>
                        ))}
                        {a.last_sync_at && (
                          <div style={{fontSize:10,color:"var(--text-muted)",marginTop:6}}>
                            Sync: {new Date(a.last_sync_at).toLocaleString()}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* ── SUBSCRIBED PROVIDERS ── */}
                    {allProviders.length > 0 && (
                      <div style={{marginBottom:6}}>
                        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
                          <span style={{
                            width:7,height:7,borderRadius:"50%",background:"var(--success)",
                            boxShadow:"0 0 0 2px rgba(var(--success-rgb,78,203,138),0.2)",display:"inline-block",flexShrink:0
                          }}/>
                          <span style={{fontSize:11,fontWeight:700,color:"var(--text-muted)",
                            textTransform:"uppercase",letterSpacing:"0.08em"}}>
                            Subscribed Providers ({allProviders.length})
                          </span>
                          {a.max_master_dd > 0 && (
                            <span style={{fontSize:11,fontWeight:700,color:ddClr(a.max_master_dd)}}>
                              · Max Master DD: {fmtPct(a.max_master_dd)}
                            </span>
                          )}
                          <div style={{flex:1,height:"0.5px",background:"rgba(255,255,255,0.07)"}}/>
                        </div>
                        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:10}}>
                          {allProviders.map((p,i)=>(
                            <ProviderCard key={i} item={p}/>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* ── PAST PROVIDERS ── */}
                    {pastTraders.length > 0 && (
                      <div style={{marginTop:18}}>
                        <div style={{height:"0.5px",background:"rgba(255,255,255,0.07)",marginBottom:16}}/>
                        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="1 4 1 10 7 10"/>
                            <path d="M3.51 15a9 9 0 1 0 .49-4.5"/>
                          </svg>
                          <span style={{fontSize:11,fontWeight:700,color:"var(--text-muted)",
                            textTransform:"uppercase",letterSpacing:"0.08em"}}>
                            Past Providers ({pastTraders.length})
                          </span>
                          <span style={{
                            fontSize:10,fontWeight:600,padding:"3px 9px",borderRadius:20,
                            background:"rgba(15,58,42,0.9)",color:"var(--success)",
                            border:"0.5px solid rgba(42,122,80,0.5)",
                            display:"inline-flex",alignItems:"center",gap:5
                          }}>
                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="var(--success)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.25C17.25 22.15 21 17.25 21 12V7L12 2z"/>
                              <polyline points="9 12 11 14 15 10"/>
                            </svg>
                            Platform Guard Protected
                          </span>
                          <div style={{flex:1,height:"0.5px",background:"rgba(255,255,255,0.07)"}}/>
                        </div>
                        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:10}}>
                          {pastTraders.map((p,i)=>(
                            <PastCard key={i} p={p}/>
                          ))}
                        </div>
                        {showBanner && <PlatformGuardBanner pastTraders={pastTraders}/>}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
